import type { PostHogConfig } from "posthog-js";

export function getPostHogOptions(): Partial<PostHogConfig> {
  return {
    api_host: `https://${window.ENV.POSTHOG_HOST}`,
    autocapture: false,
    capture_pageview: "history_change", // Tracks initial load + SPA navigations; pathname-change guard prevents replaceState overcounting
    // Privacy & compliance — do not disable these
    respect_dnt: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "[data-ph-mask]",
    },
    // Flipper handles feature flags — do not enable PostHog flags
    advanced_disable_feature_flags: true,
  };
}

export function isPostHogEnabled(): boolean {
  return window.ENV.POSTHOG_ENABLED || false;
}
